import { AbstractEffect } from './abstract.effect'

export class CloneEffect extends AbstractEffect {
  static metaInfo() {
    return {
      uuid: 'clone',
      code: 'clone',
      name: 'Clone',
      apply: ['text', 'image', 'video', 'd3']
    }
  }

  constructor(suuid, uuid) {
    super(suuid, uuid)
    this._math = 'clone'
    this._controls = {}
  }

  info() {
    const ret = super.info()
    ret.math = this._math
    ret.controls = this._controls
    return ret
  }

  configure(data) {
    super.configure(data)
    this._math = typeof data.math === 'undefined' ? this._math : data.math
    this._controls = data.controls || this._controls
  }

  frame(time, props, ctx) {
    if (!this._controls.values || !this._controls.auto)
      return props
    const val = this.value(time)
    const cfg = Object.keys(this._controls.values).reduce((acc, code) => {
      acc[code] = this._controls.auto[code]
        ? val
        : this._controls.values[code]
      return acc
    }, {})
    ctx.editor.addNextPass({
      uuid: this.uuid,
      code: this._math,
      cfg
    })
    // this.dbg.info('frame', ctx, time, val, this._controls)
    
    return props
  }

  postprocess(cfg, pass) {
    // if (!pass) 
    return pass
  }
}
